(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function init(el) {
    if (!el || el.__fr_inited) return;
    el.__fr_inited = true;

    const track = el.querySelector("[data-fr-track]");
    const slides = Array.from(el.querySelectorAll("[data-fr-slide]"));
    const dotsWrap = el.querySelector("[data-fr-dots]");

    if (!track || slides.length <= 1) return;

    const autoplay = el.getAttribute("data-autoplay") === "true";
    const intervalMs = Number(el.getAttribute("data-interval") || 3500);

    let index = 0;
    let timer = null;
    let paused = false;

    function slidesPerView() {
      // match CSS: 1 on mobile, 2 on desktop
      return window.matchMedia("(min-width: 990px)").matches ? 2 : 1;
    }

    function maxIndex() {
      const spv = slidesPerView();
      return Math.max(0, slides.length - spv);
    }

    function clampIndex(i) {
      const m = maxIndex();
      if (i < 0) return m;
      if (i > m) return 0;
      return i;
    }

    function update() {
      index = clampIndex(index);
      const slideWidth = slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap || "0") || 0;
      const x = (slideWidth + gap) * index;
      track.style.transform = `translateX(-${x}px)`;

      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll(".featured-reviews__dot");
        dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
      }
    }

    // dots (one per index step, not per slide)
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      for (let i = 0; i <= maxIndex(); i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "featured-reviews__dot" + (i === 0 ? " is-active" : "");
        b.setAttribute("aria-label", `Go to slide ${i + 1}`);
        b.addEventListener("click", () => {
          index = i;
          update();
          restart();
        });
        dotsWrap.appendChild(b);
      }
    }

    function tick() {
      if (paused || prefersReducedMotion()) return;
      index += 1;
      update();
    }

    function start() {
      if (!autoplay || prefersReducedMotion()) return;
      stop();
      timer = window.setInterval(tick, intervalMs);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      start();
    }

    // pause on hover/focus
    el.addEventListener("mouseenter", () => { paused = true; });
    el.addEventListener("mouseleave", () => { paused = false; });
    el.addEventListener("focusin", () => { paused = true; });
    el.addEventListener("focusout", () => { paused = false; });

    // update on resize (for desktop 2-up change)
    window.addEventListener("resize", () => {
      // rebuild dots if needed
      if (dotsWrap) {
        dotsWrap.innerHTML = "";
        for (let i = 0; i <= maxIndex(); i++) {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "featured-reviews__dot" + (i === index ? " is-active" : "");
          b.setAttribute("aria-label", `Go to slide ${i + 1}`);
          b.addEventListener("click", () => {
            index = i;
            update();
            restart();
          });
          dotsWrap.appendChild(b);
        }
      }
      update();
    });

    // initial
    update();
    start();
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-featured-reviews]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", () => boot(document));
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();
